/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Point_ReviewedInputs */



/**
* | output |
* | --- |
* | "Every report reviewed in house before it reaches the client" |
*
* @param {Team_Point_ReviewedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const team_point_reviewed = /** @type {((inputs?: Team_Point_ReviewedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Point_ReviewedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("每份报告在交给客户前都经过内部审核")
	return /** @type {LocalizedString} */ ("Every report reviewed in house before it reaches the client")
});